import { format } from "date-fns";
import { StyledNuevaObra } from "../../../styled/Obras";

const NuevaObraLabel = ({ identificacion, tipoGestionObra }) => {

  return (
    Object.keys(identificacion).length !== 0 && (
      <>
        <StyledNuevaObra.HeaderLabelChildrenContainer>
          <StyledNuevaObra.HeaderSecondItem>
            <strong>{identificacion.denominacionObra}</strong>
          </StyledNuevaObra.HeaderSecondItem>
        </StyledNuevaObra.HeaderLabelChildrenContainer>
        <StyledNuevaObra.HeaderThirdItem>
          {`${format(identificacion.fechaInicioObra, "dd/MM/yyyy")} - ${format(
            identificacion.fechaHastaExtensionObra ?? identificacion.fechaFinObra,
            "dd/MM/yyyy"
          )}`}
        </StyledNuevaObra.HeaderThirdItem>
      </>
    )
  );
};

export default NuevaObraLabel;
